export function LogoMark({ size = 34, invert = false }) {
  return (
    <span className="logo-type leading-none" style={{ fontSize: size * 0.62, color: invert ? "#FFFFFF" : "#002FA7" }} aria-label="BPJ">BPJ</span>
  );
}

export function Logo({ invert = false, size = "md" }) {
  const fs = size === "lg" ? "text-[1.6rem]" : "text-[0.98rem] sm:text-[1.08rem]";
  return (
    <span className={`logo-type block leading-[0.92] ${fs}`} style={{ color: invert ? "#FFFFFF" : "#002FA7" }} data-testid="brand-logo">
      <span className="block">Business</span>
      <span className="block">Performance</span>
      <span className="block">Journal</span>
    </span>
  );
}
